import React, {useState} from 'react';
import DataTable from '@preflighttech/preflight-tables';
import { Pressable, Text, View } from 'react-native';
import { COMMISSIONS_WITH_COUNT, HIDE_COMMISSION } from './queries';
import { useMutation } from '@apollo/client';
import SubNav from './SubNav';
import { Link } from 'app/src/utils/routing';
import Filter from 'app/src/elements/Filter';
import { ResetSettings } from 'app/src/elements/Pagination/ResetSettings';
import { abbreviations as states} from 'app/src/elements/states';
import Modal from '../../elements/Modal';
import EditCommission from './edit';

export const COMMISSION_TYPE_OPTIONS = [
  'Flat Payment','% of profit','Per Asset Commission'
]

import {
  CommissionsContainer
} from './elements';
import { MainContainer, ContentContainer } from '../../elements';

const inputStyle = {
  marginBottom: '10px'
}

const Commissions = () => {
  const [refetch, setRefetch] = useState();
  const [filterOptions, setFilterOptions] = useState();
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const [clickedCommission, setClickedCommission] = useState();
  const [showEditCommissionModal, setShowEditCommissionModal] = useState(false);
  const queryVariables = {
    filterColumns: [],
    filterNames: [],
    scopes: [],
  };
  const [hideCommission] = useMutation(
    HIDE_COMMISSION, { onCompleted: refetch }
  )

  const onHide = (commissionId) => {
    hideCommission({ variables: { id: commissionId }});
  };

  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });

  const columns = [
    {
      key: 'name',
      label: 'Name',
      // width: '20%',
      content: (entry) => {
        return entry.entry.name
      }
    },
    {
      key: 'functions',
      label: 'Functions',
      // width: '15%',
      // minViewportWidth: 1000,
      content: (entry) => {
        return (
          <div style={{display: 'inline-flex'}}>
            <Pressable
              onPress={() => {
                setClickedCommission(entry.entry);
                setShowEditCommissionModal(true);
              }}
            >
              <Text>Edit</Text>
            </Pressable>
          </div>
        )
      }
    }
  ]

  const buttons = (
    <View style={{display: 'flex', flexDirection: 'row'}}>
      <Filter
        clearFilters={() => {
          setFilters({})
          setShowModal(false)
        }}
        filters={filters}
        setFilters={setFilters}
      >
        <View style={{padding: '20px', justifyContent: 'space-between'}}>
          <Text>Name:</Text>
          <input
            type={'text'}
            name="name"
            onChange={e => setFilter('name', e.target.value)}
            value={filters.street || ''}
            style={inputStyle}
          />
        </View>
      </Filter>
      <ResetSettings />
    </View>
  );

  return (
    <MainContainer>
      <SubNav refetch={refetch} />
      <ContentContainer>
        <DataTable.Gql
          setRefetch={setRefetch}
          query={COMMISSIONS_WITH_COUNT}
          queryName='commissionsWithCount'
          columns={columns}
          buttons={buttons}
          lengthMenu={ [10, 25, 50, 'All'] }
          setSettings={setSettings}
          dataUpdated={data => setFilterOptions(data?.commissionsWithCount)}
          htmlTable
          queryVariables={queryVariables}
        />
        {showEditCommissionModal &&
        <Modal
          refetch={refetch}
          showModal={showEditCommissionModal}
          setShowModal={setShowEditCommissionModal}
          modalType={'Edit Commission'}
          objectName={clickedCommission.name}
        >
          <EditCommission
            setShowModal={setShowEditCommissionModal}
            refetch={refetch}
            commission={clickedCommission}
          />
        </Modal>
      }
      </ContentContainer>
    </MainContainer>
  )
}

export default Commissions;
